<svelte:options accessors/>
<script lang="ts">
    import CartItem from "./CartItem.svelte";
    import {Cart, getCart} from "../../models/cart";
    import {createEventDispatcher, onMount} from "svelte";
    import {getFormatter, getSelectedCity} from "../../utils";
    import type {AccessoryStockItem, CartStockItem, ServiceStockItem} from "../../interfaces";
    import {IDataVehicle, PlanStockItem} from "../../interfaces";
    import AccessoryItem from "./items/AccessoryItem.svelte";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import ShareCart from "../ShareCart.svelte";
    import CartConfirmVehicle from "../CartConfirmVehicle.svelte";
    import Adviser from "../Adviser.svelte";
    import IconButton from "@smui/icon-button";
    import Header from "@smui/dialog/src/Header";
    import LinearProgress from "@smui/linear-progress";
    import Snackbar, {Label} from "@smui/snackbar";
    import {ManagerVehicles} from "../../models/manager-vehicles";

    const dispatch = createEventDispatcher();

    export let cart: Cart;
    export let params: any;
    let formatter = getFormatter();
    export let dialog: any = {
        open: false,
        message: ''
    }
    let validateVehicleDialog = false;
    let adviser;
    let placaPedido: string;
    let loadingCar: boolean;
    let snackbar = {
        cmpt: null,
        message: ''
    }
    let manager: ManagerVehicles;
    export let vehicle: IDataVehicle;
    let confirmed = false;
    let notAvailable: any;

    onMount(() => {
        getCart().then(res => {
            cart = res;
            adviser = cart.adviser ? cart.adviser : {
                name: '',
                doc: ''
            };
        });
        manager = ManagerVehicles.getInstance();
        manager.selected$.subscribe((next) => {
            vehicle = next
        });
    });

    function refreshCart() {
        cart = cart;
    }

    async function removePart(p: CartStockItem) {
        const status = cart.removePart(p);
        if (status) {
            await cart.update();
            refreshCart();
        }
    }

    async function removeAccessory(a: AccessoryStockItem) {
        const status = cart.removeAccessory(a);
        if (status) {
            await cart.update();
            refreshCart();
        }
    }

    async function removeService(a: ServiceStockItem) {
        const status = cart.removeService(a);
        if (status) {
            await cart.update();
            refreshCart();
        }
    }

    async function removeRevision(a: PlanStockItem) {
        const status = cart.removeRevision(a);
        if (status) {
            await cart.update();
            refreshCart();
        }
    }

    async function removePlan(a: PlanStockItem) {
        const status = cart.removePlan(a);
        if (status) {
            await cart.update();
            refreshCart();
        }
    }

    async function updateQuantity() {
        refreshCart();
        await cart.update(false);
    }

    async function updateInstallation(data) {
        try {
            await cart.updateInstallation({
                codReferencia: data.item.reference,
                tipo: 'P',
                ciudad: data?.city?.id || '11001',
                modeloTasa: data.item.codModelo,
                incluyeInstalacion: data.installation ? '1' : '0'
            });
            refreshCart()
        } catch (e) {
            data.installation = true;
            refreshCart()
            dialog = {
                open: true,
                message: e.error ?? 'Se presento un error'
            };
        }
    }

    async function next() {
        /**
         * Se debe verificar que todos los accesorios tengan vin code
         */
        /*
        if (cart.vinAccessories) {
            await cart.update();
            dispatch('next');
        } else {
            alert('missing vincode of some accessories');
        }*/
        await cart.update();
        dispatch('next');
    }

    function closeDialog() {
        dialog = {
            open: false,
            message: ''
        }
    }

    function keepBuying() {
        if (window.history.length > 0) {
            window.history.back();
        }
    }

    function setVehicle(_) {
        vehicle = _;
    }

    async function confirm() {
        loadingCar = true;
        try {
            const body = await cart.updateVehicle(vehicle);
            manager.addVehicle(vehicle, true);
            notAvailable = body;
            confirmed = true;
            loadingCar = false;
        } catch (e) {
            snackbar.message = e.error ?? 'Se presento un error';
            snackbar.cmpt.open();
            loadingCar = false;
        }
    }

    async function queryPlacaPedido(params) {
        vehicle = null;
        loadingCar = true;
        try {
            const {query} = params;
            const url = new URL('/backend/servicio/datos-vehiculo/', window.origin);
            url.search = new URLSearchParams(query).toString()
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                setVehicle(data);
            } else {
                throw new Error();
            }
        } catch (e) {
            snackbar.message = 'No se encontró el vehículo';
            snackbar.cmpt.open();
        }
        loadingCar = false;
    }


    function validateInput(e) {
        if (e.key === 'Enter') {
            validatePlacaPedido();
        }
    }

    async function validatePlacaPedido() {
        let patternPlaca = /^[A-Za-z]{3}\d{3}$/;
        let patternPedido = /^\d+$/;
        if (patternPlaca.test(placaPedido)) {
            await queryPlacaPedido({query: {placa: placaPedido}});
        } else if (patternPedido.test(placaPedido)) {
            await queryPlacaPedido({
                query: {
                    codCia: `1`,
                    codUN: `10`,
                    ciudad: getSelectedCity(),
                    pedido: placaPedido
                }
            });
        } else {
            snackbar.message = 'No es una placa o pedido válido';
            snackbar.cmpt.open();
        }
    }
</script>
<section class="pb-3 max-w-900px mx-auto">
    {#if cart}
        <div class="container">
            {#if cart.partsWithDelivery.length > 0}
                <div class="py-15">
                    <strong class="block mb-1">Envío a domicilio</strong>
                    <div>
                        {#each cart.partsWithDelivery as product}
                            <CartItem data="{product}"
                                      on:updateQuantity={()=>updateQuantity()}
                                      on:remove={()=>removePart(product)}/>
                        {/each}
                    </div>
                </div>
                <hr>
            {/if}
            {#if cart.accessories && cart.accessories.length > 0}
                <div class="py-15">
                    <strong class="block mb-1">Accesorios</strong>
                    <div>
                        {#each cart.accessories as acc}
                            <AccessoryItem data="{acc}"
                                           {cart}
                                           on:updateInstallation={()=>updateInstallation(acc)}
                                           on:updateQuantity={()=>updateQuantity()}
                                           on:remove={()=>removeAccessory(acc)}/>
                        {/each}
                    </div>
                </div>
                <hr>
            {/if}
            {#if cart.services && cart.services.length > 0}
                <div class="py-15">
                    <strong class="block mb-1">Servicios</strong>
                    {#each cart.services as product}
                        <CartItem data="{product}"
                                  on:remove={()=>removeService(product)}
                                  on:updateQuantity={()=>updateQuantity()}/>
                    {/each}
                </div>
                <hr>
            {/if}

            {#if cart.revisions && cart.revisions.length > 0}
                <div class="py-15">
                    <strong class="block mb-1">Mantenimiento Preventivo</strong>
                    {#each cart.revisions as product}
                        <CartItem data="{product}"
                                  on:remove={()=>removeRevision(product)}
                                  on:updateQuantity={()=>updateQuantity()}/>
                    {/each}
                </div>
                <hr>
            {/if}

            {#if cart.plans && cart.plans.length > 0}
                <div class="py-15">
                    <strong class="block mb-1">Planes</strong>
                    {#each cart.plans as plan}
                        <CartItem data="{plan}"
                                  on:remove={()=>removePlan(plan)}
                                  on:updateQuantity={()=>updateQuantity()}/>
                    {/each}
                </div>
                <hr>
            {/if}
            <div class=" pt-ii pb-1 border-bottom">
                <div class="mb-1">
                    <strong>Medios de pago</strong>
                </div>
                <div class="box-l sx-ii">
                    <img src="/static/storefront/pix/checkout/pse.png" alt="pse" height="35">
                    <img src="/static/storefront/pix/checkout/visa.png" alt="visa" height="35">
                    <img src="/static/storefront/pix/checkout/mastercard.png" alt="mastercard" height="35">
                </div>
            </div>
            <div class=" pt-ii pb-1 border-bottom">
                <div class="box-b">
                    <strong>Subtotal de tu compra</strong>
                    <h3>{formatter(cart.subtotal)}</h3>
                </div>
            </div>
            {#if cart && adviser}
                <Adviser {cart}
                         {adviser}/>
            {/if}
            <!--Vehicle validation-->
            <div class="s:box-b bg-gray px-ii my-ii">
                <div class="box text-c p-1">
                    <img class="mr-ii hidden s:block" height="24" src="/static/storefront/pix/icons/exclamacion.svg">
                    <img class="mr-ii hidden mobile-icon" height="16" src="/static/storefront/pix/icons/exclamacion.svg">
                    <span>Confirme si los productos son compatibles con su vehículo</span>
                </div>
                <div class="naui-field py-ii s:w-50">
                    {#if vehicle}
                        {#if loadingCar}
                            <LinearProgress indeterminate/>
                            <span>Consultando...</span>
                        {:else}
                            {#if confirmed}
                                {#if !notAvailable}
                                    <div class="box p-1">
                                        <img class="mr-ii hidden s:block" height="24"
                                             src="/static/storefront/pix/material/check_circle.svg">
                                        <img class="mr-ii hidden mobile-icon" height="16"
                                             src="/static/storefront/pix/material/check_circle.svg">
                                        <span style="color: #06741B;">
                                    Los productos son compatibles con su vehículo
                                </span>
                                    </div>
                                {:else}
                                    <div class="box p-1">
                                        <img class="mr-ii hidden s:block" height="24"
                                             src="/static/storefront/pix/material/alert_circle.svg">
                                        <img class="mr-ii hidden mobile-icon" height="16"
                                             src="/static/storefront/pix/material/alert_circle.svg">
                                        <span style="color: #C3002F;">
                                    Algunos productos no están disponibles o no son compatibles
                                </span>
                                    </div>
                                {/if}
                            {/if}

                            <div class="bg-gray s:py-1 px-1">
                                {#if vehicle.placa}
                                    <b class="mb-ii">Placa</b>
                                    <p>{vehicle.placa}</p>
                                {/if}
                                <b class="mb-ii">Modelo</b>
                                <p>{vehicle.descModeloTASA}</p>
                                <p>{vehicle.descModelo}</p>
                            </div>
                            <div class="box sx-ii">
                                <button class="btn accent" style="font-size: 13px;"
                                        on:click={()=>vehicle=null}>
                                    ASIGNAR OTRO
                                </button>
                                {#if !confirmed}
                                    <button class="btn accent" style="font-size: 13px;"
                                            on:click={()=>confirm()}>
                                        CONFIRMAR
                                    </button>
                                {/if}
                            </div>
                        {/if}
                    {:else}
                        <div class="box">
                            <input type="text"
                                   class="naui-input"
                                   placeholder="Ingrese placa o pedido"
                                   bind:value={placaPedido}
                                   on:keypress={validateInput}>
                            <img height="20" alt="Buscador placa o pedido" class="pl-ii pointer"
                                 src="/static/storefront/pix/icons/lupa-buscador.svg"
                                 on:click={validatePlacaPedido}>
                        </div>
                    {/if}
                </div>
            </div>
            <div class="box my-15">
                <div class="btn accent min-w-200px text-c"
                     on:click={()=>next()}>
                    Continuar
                </div>
            </div>
            <div class="box">
                <a on:click={()=>keepBuying()} class="underlined">Seguir comprando</a>
            </div>
            {#if cart}
                <ShareCart {cart}/>
            {/if}
        </div>

    {/if}
</section>

<Dialog bind:open={validateVehicleDialog}
        scrimClickAction="close"
        escapeKeyAction="close"
        aria-describedby="mandatory-content">
    <Header>
        <IconButton
            action="close"
            class="material-icons"
            style="float: right;"
            on:click={() => validateVehicleDialog = false}>
            close
        </IconButton>
    </Header>
    <Content id="mandatory-content">
        <CartConfirmVehicle {cart}
                            {params}
                            on:next/>
    </Content>
</Dialog>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbar.cmpt}>
    <Label>{snackbar.message}</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbar.cmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>

<style>
    @media (max-width: 639px) {
        .mobile-icon {
            display: block;
        }
    }
</style>